// extracted by mini-css-extract-plugin
var _1 = "pBVnE";
var _2 = "XzX1A";
var _3 = "MqbJQ";
var _4 = "huVxG";
var _5 = "eJVFX";
var _6 = "frSqi";
export { _1 as "base", _2 as "control", _3 as "label", _4 as "separator", _5 as "tooltipContent", _6 as "tooltipTitle" }
